export default __webpack_public_path__ + "static/AvenirLTStd-MediumOblique-40ec483204d053bc29cba9b206f3decc.woff";